import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Switch,
  CircularProgress,
} from "@mui/material";
import Parse from "parse";
import { useNotify } from "react-admin";

const MessagingSettingsDialog = ({ open, onClose }) => {
  const [messagingEnabled, setMessagingEnabled] = useState(true);
  const [loading, setLoading] = useState(false);
  const notify = useNotify();

  useEffect(() => {
    if (open) loadSettings();
  }, [open]);

  const loadSettings = async () => {
    try {
      setLoading(true);
      const query = new Parse.Query("GameSettings");
      let obj = await query.first({ useMasterKey: true });
      if (obj) setMessagingEnabled(obj.get("messaging") === true);
    } catch (error) {
      console.error("Error fetching settings:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const query = new Parse.Query("GameSettings");
      let obj = await query.first({ useMasterKey: true });
      if (!obj) {
        notify("❌ GameSettings not found", { type: "error" });
        return;
      }
      obj.set("messaging", messagingEnabled);
      await obj.save(null, { useMasterKey: true });
      window.dispatchEvent(
        new CustomEvent("messaging-status-changed", {
          detail: { enabled: messagingEnabled },
        })
      );
      notify("✅ Messaging settings updated!", { type: "success" });
      onClose();
    } catch (error) {
      console.error("Error saving settings:", error);
      notify("❌ Error saving settings", { type: "error" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          bgcolor: "#2a2a2a",
          borderRadius: "8px",
          color: "white",
          "& .MuiTypography-root": { fontSize: "14px" },
        },
      }}
    >
      <DialogTitle sx={{ color: "white", fontWeight: 600, fontSize: "16px" }}>
        Messaging Settings
      </DialogTitle>
      <DialogContent dividers sx={{ color: "white" }}>
        <Box display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            bgcolor="#1f1f1f"
            p={1.5}
            borderRadius={1}
          >
            <Typography color="white">Enable Messaging</Typography>
            <Switch
              checked={messagingEnabled}
              onChange={(e) => setMessagingEnabled(e.target.checked)}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, py: 2 }}>
        <Button
          onClick={onClose}
          sx={{
            bgcolor: "#333",
            color: "white",
            textTransform: "none",
            px: 4,
            fontSize: "14px",
            "&:hover": { bgcolor: "#444" },
          }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={loading}
          sx={{
            bgcolor: "#FFD600",
            color: "black",
            textTransform: "none",
            px: 4,
            fontWeight: 600,
            fontSize: "14px",
            "&:hover": { bgcolor: "#FFC107" },
          }}
          startIcon={loading && <CircularProgress size={18} color="inherit" />}
        >
          {loading ? "Saving..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessagingSettingsDialog;
